
const initialState = {
  customFullkitDropdown: [],
  loading: true,
  error: null,
};

const CustomFullkitReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case "GET_CUSTOM_FULLKIT_DROPDOWN_REQUEST":
      return {
        ...state,
        customFullkitDropdown: payload,
        loading: true,
        error: null,
      };
    case "GET_CUSTOM_FULLKIT_DROPDOWN_SUCCESS":
      return {
        ...state,
        customFullkitDropdown: payload,
        loading: false,
        error: null,
      };
    case "GET_CUSTOM_FULLKIT_DROPDOWN_ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default CustomFullkitReducer;
